// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"conteiner_conteiner__2Dfqh"};